<template>
  <v-container fill-height :fluid="$vuetify.breakpoint.lgAndDown">
    <v-row
      justify="center"
      v-if="$keycloak.hasResourceRole('admin', 'po-viewer')"
    >
      <v-col sm="4">
        <div>
          Sélectionnez un centre de coût dans la navigation ou saisissez un N°
        </div>
        <div>
          <v-text-field
            class="mt-2"
            outlined
            dense
            counter
            maxlength="5"
            v-model="costcenter"
            label="Centre de coût"
            :hint="message"
            autofocus
          ></v-text-field>
        </div> </v-col
    ></v-row>
    <v-row justify="center" v-if="$keycloak.hasResourceRole('si', 'po-viewer')">
      <v-col sm="4">
        <div>Sélectionnez un compte dans la navigation</div>
      </v-col></v-row
    >
  </v-container>
</template>

<script>
export default {
  props: ["costcenters"],
  data: () => ({
    costcenter: "",
    message: "",
  }),
  watch: {
    costcenter: function () {
      if (
        this.costcenter.length === 5 &&
        this.costcenters.map((cc) => cc.number).indexOf(this.costcenter) > -1
      ) {
        this.$router.push(`/validations?costcenter=${this.costcenter}`);
      } else {
        if (this.costcenter.length === 5) {
          this.message = "Ce centre de coûts n'existe pas";
        } else {
          this.message = "";
        }
      }
    },
  },
};
</script>
